export default __webpack_public_path__ + "static/media/noDataFound.d3ba9460.png";